import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FeedbackModal({
  isOpen,
  onClose
}: FeedbackModalProps) {
  const [feedback, setFeedback] = useState('');
  if (!isOpen) return null;
  const handleSubmit = () => {
    // Handle feedback submission
    console.log('Feedback submitted:', feedback);
    setFeedback('');
    onClose();
  };
  return <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-30 z-50 transition-opacity" onClick={onClose} data-id="element-923" />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-start justify-center pt-32 pointer-events-none" data-id="element-924">
        <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl pointer-events-auto" onClick={e => e.stopPropagation()} data-id="element-925">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-926">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-927">
              Share feedback
            </h2>
            <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded transition-colors" data-id="element-928">
              <XIcon size={20} className="text-gray-500" data-id="element-929" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6" data-id="element-930">
            <textarea value={feedback} onChange={e => setFeedback(e.target.value)} placeholder="Let us know what you think, and what other features you'd like to see." className="w-full h-48 px-4 py-3 text-base text-gray-900 placeholder-gray-400 border-2 border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none" data-id="element-931" />

            <div className="mt-4 flex items-center justify-between" data-id="element-932">
              <p className="text-sm text-gray-600" data-id="element-933">
                Have a specific issue?{' '}
                <a href="#" className="text-blue-600 hover:underline" data-id="element-934">
                  Contact support
                </a>{' '}
                or{' '}
                <a href="#" className="text-blue-600 hover:underline" data-id="element-935">
                  read our docs
                </a>
                .
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200" data-id="element-936">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-937">
              Cancel
            </button>
            <button onClick={handleSubmit} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-938">
              Send feedback
            </button>
          </div>
        </div>
      </div>
    </>;
}